import $ from 'jquery';
import _ from 'lodash';
import * as signalR from '@microsoft/signalr';
import { fabric } from '../common/fabric';
import { ui } from '../common/ui';
import { logError, jsonParse, util } from '../common/util';
import { drawing, getPrintRangeFromCanvas } from '../common/drawing';
import { parts } from '../common/parts';
import { userinfo } from '../common/userinfo';
import { split } from './split';
import { API, SIGNALR_ACTION } from '../../utilities/constants';
import { headReplace } from '../../utilities/stringUtil';
import AuthProvider, { needTokenUpdate } from '../../utilities/authProvider';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import * as StringUtil from '../../utilities/stringUtil';
import { messageUtility } from '../../utilities/messageUtility';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import { isPrimaryCompany } from '../../utilities/roleUtility';
import { isIPad } from '../../utilities/commonUtil';
import CustomHttpClient from '../common/custom-httpclient';
import { places } from './places';

function _client() {
  /**
   * Socket
   * @type {@microsoft/signalr.HubConnection}
   */
  this._socket = undefined;

  // 接続先URL
  this.url = API.nfs;
  this.connect_url = `${API.signalr}/canvas`;

  // 送信者ユニークID
  this._sender = undefined;

  // ロード中
  this._loading = false;

  // リトライ回数
  this._retry = 0;
  // 接続中部屋ID
  this._room_id = '';
  this._place_id = '';
  // 画像最大サイズ
  // window_height取得
  this.winHeight = $(window).height();

  // 手動でsocketをstopしたかどうかエラー時などと区別するため
  this.manualSocketStop = false;

  this._clientId = util.getUuid();
  this._id = null;

  // Modify this function to define what to track
  this._loginId = LocalStorageService.getItem('login_id');
  this.getWebSocketRequestId = function(actionName) {
    return `${this._loginId}_${this._clientId}_${actionName}`;
  };
  this.OUTSIDE_DIMENSIONS = {};
}

// sendJsonを間引く時間(ミリ秒) 連続で実行される場合にこの間隔でのみ実行される
const _sendJsonThrottleTime = 300;

/**
 * このプロジェクトで使われる JSON の形式に対してエラー出力を行う処理
 * @param {*} str JSON文字列
 * @param {*} logMessage console.logの出力内容
 * @returns {Object|NULL}
 *  渡ってきたデータがJSON変換できなかったり、result プロパティが明示的に false の場合
 *    ログを出力しNULL値を返します。
 *  result プロパティが仕様上存在しなかったり、明示的に true の場合
 *    JSON.parse の結果のオブジェクトを返します。
 *
 *  SignalRで送信されるデータの中には
 *  result プロパティを持つものと持たないものがあるので両方に対応しています
 *  →
 *  TODO:現状は全てのレスポンスでresultプロパティを持つはず nullを返す必要ないので要修正
 */
export const getJsonParseData = (str, logMessage) => {
  const { parseResult, parseErrorMessage } = jsonParse(str);

  if (
    parseResult &&
    parseResult.result === false &&
    parseResult.resultCode === 'nodata'
  ) {
    return parseResult;
  }

  if (
    !parseResult ||
    parseResult === 'Error' ||
    (parseResult.result === false && !parseResult.errorMessage)
  ) {
    console.error(
      'Error',
      logMessage,
      parseResult === 'Error' ? parseErrorMessage : parseResult
    );
    return null;
  }
  return parseResult;
};

/**
 * 接続感知関数
 */
const socketConnected = socket => {
  if (_.isUndefined(socket)) {
    return false;
  }
  /*  ref: node_modules/@microsoft/signalr/src/HubConnection.ts
  HubConnectionState.Connected
  */
  return socket.connectionState === signalR.HubConnectionState.Connected;
};

/**
 * 認証サーバーからトークンの最新の情報を得る
 */
_client.prototype.getToken = async () => {
  let token = SessionStorageService.getToken();
  if (_.isEmpty(token)) {
    await AuthProvider.instance.redirectLoginPage();
  }

  if (needTokenUpdate(token)) {
    token = await AuthProvider.instance.silentTokenUdate();
  }
  return token;
};

_client.prototype.setCanvasUpdateKey = function(data) {
  this._id = data.Id;
};

_client.prototype.getCanvasUpdateKey = function() {
  return {
    Id: this._id,
  };
};

_client.prototype.clearCanvasUpdateKey = function() {
  this._id = null;
};

// クライアント初期化
_client.prototype.init = function() {
  var self = this;
  self.manualSocketStop = false;
  self.OUTSIDE_DIMENSIONS = {
    MASTER_MENU: $('.master-navi').width() || 210,
    FUNCTION_MENU: $('.func-navi').width() || 210,
    LAYOUT_HEADER: $('.layout-header').height() || 40,
    LAYOUT_TOOL: $('div.layout-tool').offsetHeight || 64,
    LAYOUT_TOOL_TABS: $('#tab-tool-home__link').height() || 24,
    LAYOUT_SELECT_HEADER: $('.layout-select-header').height() || 34,
  };
  // 更新者のユーザーIDを設定
  self._sender = userinfo.getUserId();

  // サーバへ接続
  self._socket = new signalR.HubConnectionBuilder()
    .withUrl(this.connect_url, {
      accessTokenFactory: async () => await self.getToken(),
      httpClient: new CustomHttpClient(),
    })
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  ui.showLoaderBg('loading_msg');

  // 通信開始
  self.startConnect();

  // 切断時
  self._socket.onclose(function() {
    console.log('debug', 'socket onClose', self._socket);

    try {
      if (self._loading) {
        ui.showLoaderBg('loading_msg');
      } else {
        // 数秒後に再接続を行う(リトライ１０回)
        // 手動でsocketをstopした場合は何もしない 判定しないと再接続してしまう
        if (!self.manualSocketStop) {
          ui.showLoaderBg('disconnect_msg');
          // BLDE_V2-17750 対応 >>> ------------------------------
          ui.toolboxSelect(drawing.historyTool);
          // <<< ------------------------------------------------

          setTimeout(function() {
            self.init();
          }, 3000);
        }
      }
    } finally {
      self.manualSocketStop = false;
    }
  });

  /**
   * joinRoom のエラーメッセージ受信用
   */
  self._socket.on('joinRoom', function(data) {
    console.log('debug', 'socket.on joinRoom', data);
  });

  /**
   * UnEditLock のエラーメッセージ受信用
   */
  // eslint-disable-next-line no-unused-vars
  self._socket.on('unEditLock', function(data) {
    console.error('socket.on UnEditLock', data);
  });

  /**
   * フロント側で汎用利用できるメッセージ
   * 自分を含めた全員に通知される
   */
  self._socket.on('publish', function(data) {
    if (self._loading) {
      return;
    }
    self._loading = true;

    const parseResult = getJsonParseData(data, 'socket.on publish');
    if (_.isNull(parseResult)) {
      self.error();
      return;
    }
    console.log('socket.on publish', parseResult);

    if (parseResult.data.Sender === self._sender) {
      self._loading = false;
      return;
    }

    switch (parseResult.data.Action) {
      case 'menuReloadParts':
        // 部品の同期
        const { partsGroupId } = jsonParse(parseResult.data.Params).parseResult;
        parts.reloadParts(Number(partsGroupId), true);
        break;
      case 'menuReloadPartsGroup':
        // 部品グループの同期
        parts.reloadPartsGroup();
        break;
      case 'menuReloadPartsScale':
        // reload parts scale
        const { scale } = jsonParse(parseResult.data.Params).parseResult;
        parts.updatePartsScale(scale);
        break;
      default:
        throw new Error(`socket.on publis Action:${parseResult.data.Action}`);
    }

    self._loading = false;
  });
  // calculate the left side width, includes: master + function menu
  self.calculateLeftSideOffset = function() {
    if (isIPad()) {
      return 0;
    }
    let leftSideOffSet = 0;
    if (SessionStorageService.isOpeningMasterMenu()) {
      leftSideOffSet += self.OUTSIDE_DIMENSIONS.MASTER_MENU;
    }
    if (SessionStorageService.isOpeningFunctionMenu()) {
      leftSideOffSet += self.OUTSIDE_DIMENSIONS.FUNCTION_MENU;
    }
    return leftSideOffSet;
  };
  // header height, includes: layout tool + layout-header + layout-tool-tabs + layout-select-header
  self.getHeaderHeight = function(isLock) {
    const headerHeight =
      self.OUTSIDE_DIMENSIONS.LAYOUT_HEADER +
      self.OUTSIDE_DIMENSIONS.LAYOUT_TOOL_TABS +
      self.OUTSIDE_DIMENSIONS.LAYOUT_TOOL +
      self.OUTSIDE_DIMENSIONS.LAYOUT_SELECT_HEADER;
    // if locked, layout tool will be hidden some roles or isExtraProxiLogin
    return (isLock && !isPrimaryCompany(userinfo.getUserType())) ||
      SessionStorageService.isExtraProxiLogin()
      ? headerHeight -
          self.OUTSIDE_DIMENSIONS.LAYOUT_TOOL -
          self.OUTSIDE_DIMENSIONS.LAYOUT_TOOL_TABS
      : headerHeight;
  };
  // relative point base on backgroundPrint and viewportTransform
  self.getRelativePoint = function(headerHeight = 0) {
    const x =
      (window.innerWidth -
        drawing.backgroundPrint.width -
        self.calculateLeftSideOffset()) /
        2 -
      drawing.backgroundPrint.left -
      drawing._canvas.viewportTransform[4];
    const y =
      (window.innerHeight - headerHeight - drawing.backgroundPrint.height) / 2 -
      drawing.backgroundPrint.top -
      drawing._canvas.viewportTransform[5];
    return { x, y };
  };

  /**
   * オブジェクトの更新
   */
  self.updateObject = function(data, callMethodName) {
    if (self._loading) {
      return;
    }
    self._loading = true;

    const parseResult = getJsonParseData(
      data,
      `client_v2 updateObject ${callMethodName}`
    );

    if (
      parseResult &&
      parseResult.result === false &&
      parseResult.resultCode === 'nodata'
    ) {
      self._loading = false;
      ui.showCopyNodataMessage();
      return;
    }

    if (_.isNull(parseResult) || parseResult.result === false) {
      self.error(parseResult && parseResult.errorMessage);
      self._loading = false;
      return;
    }
    // console.log(`client_v2 updateObject ${callMethodName}`, parseResult);

    // 他ブラウザからや、他の日付からのコピー時に
    // この処理が行われるときは
    // undoバッファを削除する
    drawing.historyBufferInit();

    const canvas = parseResult.data.CanvasJson;
    //console.log('sendJson', 'before loadFromJSON', canvas);
    if (_.isUndefined(canvas)) {
      self._loading = false;
      return;
    }

    // 背景画像処理
    if (_.isUndefined(parseResult.data.Background)) {
      throw new Error('on sendJson canvas.Background is Undefined');
    }

    const backgroundImagePath = headReplace(
      parseResult.data.Background,
      '/share/',
      `${API.nfs}/`
    );

    const recoverSelect = (() => {
      if (drawing._toolbox_selected !== 'tool-select') {
        return () => {};
      }
      const prevActiveObjectState = new Map(
        drawing._canvas.getActiveObjects().map(obj => [
          obj.uuid,
          {
            hasBorders: obj.hasBorders,
            hasControls: obj.hasControls,
          },
        ])
      );
      const isObjectEditing = $('#tab-tool-edit').hasClass('active');
      return () => {
        const activeObjects = Array.from(prevActiveObjectState.keys())
          .map(uuid => fabric.eg.getFromUuid(uuid))
          .filter(obj => drawing._canvas.contains(obj));
        if (activeObjects.length === 0) {
          return;
        }
        if (activeObjects.length > 1) {
          activeObjects.forEach(obj => {
            if (prevActiveObjectState.has(obj.uuid)) {
              const state = prevActiveObjectState.get(obj.uuid);
              obj.hasBorders = state.hasBorders;
              obj.hasControls = state.hasControls;
            }
          });
        }
        const selection =
          activeObjects.length > 1
            ? new fabric.ActiveSelection(activeObjects, {
                canvas: drawing._canvas,
              })
            : activeObjects[0];
        drawing._canvas.setActiveObject(selection);
        isObjectEditing && $('#tab-tool-edit__link').trigger('click');

        const transform = drawing._canvas._currentTransform;
        if (_.isNil(transform)) {
          return;
        }
        transform.target = selection;
        drawing._canvas._transformObject(drawing._lastMouseMoveEvent);
      };
    })();

    const recoverPointEdit = (() => {
      if (drawing._toolbox_selected !== 'tool-point') {
        return () => {};
      }
      const editPoint = drawing._canvas
        .getObjects()
        .find(obj => obj.isEditPoint);
      if (_.isNil(editPoint) || _.isNil(editPoint.poly)) {
        return () => {};
      }
      const targetObjectUuid = editPoint.poly.uuid;
      return () => {
        $('button.tool-select').trigger('click');
        const target = fabric.eg.getFromUuid(targetObjectUuid);
        if (!drawing._canvas.contains(target)) {
          return;
        }
        drawing._canvas.setActiveObject(target);
        drawing._canvas.fire('mouse:dblclick', { target });

        const transform = drawing._canvas._currentTransform;
        if (_.isNil(transform) || _.isNil(transform.target)) {
          return;
        }
        if (
          !transform.target.isEditPoint ||
          _.isNil(transform.target.pointIndex)
        ) {
          return;
        }
        const points = drawing._canvas
          .getObjects()
          .filter(obj => obj.isEditPoint);
        const targetPoint = points.find(
          obj => obj.pointIndex === transform.target.pointIndex
        );
        drawing._canvas.setActiveObject(targetPoint);
        drawing._canvas.fire('mouse:down', { target: targetPoint });
        transform.target = targetPoint;
        drawing._canvas._transformObject(drawing._lastMouseMoveEvent);
      };
    })();

    const recoverPrintRange = (() => {
      if (drawing._toolbox_selected !== 'tool-print-range') {
        return () => {};
      }
      const printFrame = drawing._canvas
        .getObjects()
        .find(obj => obj.isPrintFrame);
      if (_.isNil(printFrame)) {
        return () => {};
      }
      return () => {
        drawing._canvas.add(printFrame);
        drawing._canvas.setActiveObject(printFrame);
      };
    })();

    const recoverMake = (() => {
      const making = drawing._making;
      if (_.isNil(making)) {
        return () => {};
      }
      return () => {
        drawing._making = making;
        drawing._canvas.add(making);
      };
    })();

    const canvasObj = _.omit(JSON.parse(canvas), ['backgroundImage']);
    const prevBackgroundImage = drawing._canvas.backgroundImage;
    drawing._canvas.loadFromJSON(canvasObj, function() {
      self.setCanvasUpdateKey(parseResult.data);
      const printRange = getPrintRangeFromCanvas(parseResult.data);
      // set print range to get the backgroundPrint dimension
      drawing.setBackgroundPrint(printRange);
      const updateCanvas = () => {
        // オフセット値(用紙左の余白部分)の適用
        // canvasの初期化処理時にはオフセット値を適用する
        drawing._canvasLock = parseResult.data.Lock === 1;
        self._loading = false;
        drawing.updateObjectCount();

        // ツールモードを元に戻す
        // これを行うことでオブジェクト非選択状態に変更できる
        drawing.toolboxSelect(drawing._toolbox_selected, false);
        drawing.setToolbarItem();

        recoverMake();
        recoverSelect();
        recoverPointEdit();
        recoverPrintRange();
      };

      if (StringUtil.isNullOrEmpty(backgroundImagePath)) {
        drawing._canvas.backgroundImage = false;
        updateCanvas();
      } else {
        let src = null;
        // 背景画像変更
        if (StringUtil.isNullOrEmpty(canvas.backgroundImage)) {
          src = backgroundImagePath;
        } else {
          src = canvas.backgroundImage;
        }

        if (
          !_.isEmpty(prevBackgroundImage) &&
          prevBackgroundImage.getSrc() === src
        ) {
          src = prevBackgroundImage;
        }

        drawing._canvas.setBackgroundImage(src, function() {
          self.resizeBackgroundImage(drawing._canvas);
          updateCanvas();
        });
      }

      if (callMethodName === 'copyCanvas') {
        self.flush();
      }
    });
  };

  /**
   * 仕様：
   * デフォルト背景（背景未設定でも直近の背景を表示する処理）が表示されている状態で、
   * オブジェクトの編集が行われた場合に更新する
   * Canvas.objectsの中にあるbackgroundImage、Canvas.Backgroundがデフォルト背景
   * -
   * 色々判別するつもりがファイルの有無だけになってしまいましたが、
   * 背景のAutoSaveを実施するかの判断処理として、修正する箇所が限定できるので、
   * このままとさせていただきます
   */
  self.isAutoSaveBackgroundImage = function(src) {
    if (StringUtil.isNullOrEmpty(src)) {
      console.log('isAutoSaveBackgroundImage is null or empty');
      return false;
    } else {
      console.log('isAutoSaveBackgroundImage is not null or empty');
      return true;
    }
  };

  /**
   * 背景画像をキャンバスに埋め込むためのリサイズ処理を行う
   * ロジックはV1のソースから移植
   * すでにimageObjectSetScaleという処理があり、そちらを使用するようにした方がいいかも。
   * もとから２系統あったが処理および対象に若干の違いがあるので、全体把握をしてから修正した方がベスト。
   */
  self.resizeBackgroundImage = function(canvas) {
    var w = canvas.backgroundImage.width;
    var h = canvas.backgroundImage.height;
    var sx = w / 1000;
    var sy = h / 650;
    var sc = sx;
    if (sy > sx) {
      sc = sy;
    }
    if (sc < 1.0) {
      sc = 1.0;
    }
    canvas.backgroundImage.scaleX = 1 / sc;
    canvas.backgroundImage.scaleY = 1 / sc;
    // Start DEM-860, Luvina Modify
    canvas.backgroundImage.top = 0;
    canvas.backgroundImage.left = drawing.leftWidthDistance || 0;
    // End DEM-860, Luvina Modify
    canvas.requestRenderAll();
    // 値が入っていないようなのでコメントアウト（必要なものなら見直し必須）
    //drawing._receivedNo = data.no;
    canvas._loaded = true;
  };

  /**
   * オブジェクト作成,削除,移動などの他端末更新データの受信
   */
  self._socket.on('sendJson', function(data) {
    self.updateObject(data, 'sendJson');
  });

  /**
   * 背景画像変更
   */
  self._socket.on('setBackgroundImage', function(data) {
    self.updateObject(data, 'setBackgroundImage');
  });

  /**
   * 別日付や別場所からのオブジェクトコピー機能
   */
  self._socket.on('copyCanvas', function(data) {
    self.updateObject(data, 'copyCanvas');
  });

  /**
   * 初期ロード時などのCanvas読み込み処理
   */
  self._socket.on('loadCanvas', function(data) {
    const parseResult = getJsonParseData(data, 'socket.on.loadCanvas');
    if (_.isNull(parseResult)) {
      self.error();
      return;
    }
    // console.log('socket.on loadCanvas', parseResult);

    let canvas = parseResult.data.CanvasJson;

    if (_.isUndefined(canvas)) {
      throw new Error('on loadCanvas data.CanvasJson is Undefined');
    }

    // 背景画像処理
    if (_.isUndefined(parseResult.data.Background)) {
      throw new Error('on loadCanvas data.Background is Undefined');
    }
    const backgroundImagePath = headReplace(
      parseResult.data.Background,
      '/share/',
      `${API.nfs}/`
    );

    drawing._canvas.loadFromJSON(canvas, function() {
      self.setCanvasUpdateKey(parseResult.data);
      // undo/redo 履歴保存の初期化
      drawing.historyBufferInit();
      const printRange = getPrintRangeFromCanvas(parseResult.data);
      // set print range to get the backgroundPrint dimension
      drawing.setBackgroundPrint(printRange);
      const updateCanvas = () => {
        drawing._canvasLock = parseResult.data.Lock === 1;
        const headerHeight = self.getHeaderHeight(parseResult.data.Lock === 1);
        const relativePoint = self.getRelativePoint(headerHeight);
        drawing._canvas.relativePan(
          new fabric.Point(relativePoint.x, relativePoint.y)
        );
        drawing._canvas.requestRenderAll();
        self._loading = false;
        ui.hideLoaderBg();
        drawing.updateObjectCount();

        drawing.toolboxSelect(drawing._toolbox_selected);
        drawing.setToolbarItem();

        // ロック状態の復帰
        ui.lockRoom(parseResult.data.Lock === 1);
      };

      if (backgroundImagePath === '') {
        drawing._canvas.backgroundImage = false;
        updateCanvas();
      } else {
        let src = null;
        if (_.isUndefined(canvas.backgroundImage)) {
          src = backgroundImagePath;
        } else {
          src = canvas.backgroundImage.src;
        }
        drawing._canvas.setBackgroundImage(src, function(img) {
          if (img !== null) {
            self.resizeBackgroundImage(drawing._canvas);
          } else {
            console.warn(
              `Can not load background image! File not found(${src})`
            );
          }
          updateCanvas();
        });
      }
      places.bindPlaceItemClick();
    });
  });

  // 職長作業ロック
  self._socket.on('editLock', function(data) {
    console.log('debug', 'socket.on editLock', data);
    const parseResult = getJsonParseData(data, 'socket.on.editLock');
    if (_.isNull(parseResult)) {
      self.error();
      return;
    }
    ui.lockRoom(parseResult.data.lock);
  });

  /**
   * 印刷範囲設定 確定
   */
  self._socket.on('setPrintRange', function(data) {
    console.log('debug', 'socket.on setPrintRange', data);
    const parseResult = getJsonParseData(data, 'socket.on.setPrintRange');
    if (_.isNull(parseResult)) {
      self.error();
      return;
    }

    const printRange = getPrintRangeFromCanvas(parseResult.data);

    drawing.setBackgroundPrint(printRange);
  });

  /**
   * 印刷
   */
  self._socket.on('print', function(data) {
    const parseResult = getJsonParseData(data, 'socket.on print');
    if (_.isNull(parseResult)) {
      // BLDE_V2-17139対応（改行が置き換えられるので、それを使用するためにpreタグを使用。preタグはリスクがあるので、このメッセージのみに適用）
      self.onPrintError(`<pre>${messageUtility.getMessage('E-001-354')}</pre>`);
      return;
    }
    self.onPrint(parseResult.data.Path);
  });

  /**
   * 分割画面表示時に取得したデータを表示する処理
   */

  self._socket.on('loadMultipleCanvas', function(data) {
    const parseResult = getJsonParseData(data, 'socket.on.loadMultipleCanvas');
    if (_.isNull(parseResult)) {
      self.error();
      return;
    }
    console.log('debug', 'socket.on loadMultipleCanvas', parseResult, split);

    let canvas = parseResult.data.CanvasJson;
    if (_.isUndefined(canvas)) {
      throw new Error('on loadMultipleCanvas data.CanvasJson is Undefined');
    }

    // 背景画像処理
    if (_.isUndefined(parseResult.data.Background)) {
      throw new Error('on loadMultipleCanvas data.Background is Undefined');
    }
    const backgroundImagePath = headReplace(
      parseResult.data.Background,
      '/share/',
      `${API.nfs}/`
    );

    var roomId = parseResult.data.RoomId;

    let pos = split._roomIds[roomId];
    const canvasObj =
      getJsonParseData(
        canvas,
        'socket.on.loadMultipleCanvas parse CanvasJson'
      ) || {};
    split.setDummyUuid(canvasObj.objects);
    split._canvas[pos].loadFromJSON(canvasObj, function() {
      const updateCanvas = () => {
        split._canvas[pos].requestRenderAll();
      };
      if (backgroundImagePath === '') {
        split._canvas[pos].backgroundImage = false;
        updateCanvas();
      } else {
        let src = null;
        if (
          _.isUndefined(split._canvas[pos].backgroundImage) ||
          split._canvas[pos].backgroundImage === null
        ) {
          src = backgroundImagePath;
        } else {
          src = split._canvas[pos].backgroundImage.src;
        }
        split._canvas[pos].setBackgroundImage(src, function(img) {
          if (img !== null) {
            self.resizeBackgroundImage(split._canvas[pos]);
          }
          updateCanvas();
        });
      }
    });
  });
};

/**
 * 接続開始
 */
_client.prototype.startConnect = function() {
  var self = this;
  self._socket
    .start()
    .then(async function() {
      self._retry = 0;
      if (self._room_id != '') {
        await self.joinRoom();
      }
      //再接続時の処理
      if (self._connected_err) {
        self._connected_err = false;
      }
    })
    .catch(function(err) {
      console.log('startConnect', 'retry', self._retry, err);
      // 接続失敗時 指定回数 リトライ
      if (self._retry < 10) {
        setTimeout(async function() {
          // 数秒後にリトライ
          await self.startConnect();
        }, 2000);
        self._retry++;
      } else {
        ui.gobackPlaceList(
          '通信エラーが発生しました。</br>電波の良いところで再度お試しください。'
        );
      }
    });
};

_client.prototype.endConnect = async function() {
  var self = this;
  if (self._socket) {
    self.manualSocketStop = true;
    return self._socket.stop();
  }
};

// エラー時の処理
_client.prototype.error = function(errorMessage) {
  if (errorMessage) {
    ui.showPopupMessage(errorMessage);
  } else {
    ui.showLoaderBg('server_err_msg');
    setTimeout(function() {
      location.reload();
    }, 10000);
  }
};

// 汎用的に使えるデータを送信
_client.prototype.dataPublish = async function(actionName, dataObjects) {
  var self = this;
  console.log('debug', 'dataPlublish', socketConnected(self._socket));
  if (socketConnected(self._socket) === false) {
    return;
  }
  const token = await self.getToken();
  if (self._loading) {
    return;
  }
  self._socket
    .invoke(
      'Publish',
      JSON.stringify({
        RoomId: self._room_id,
        FieldId: userinfo.getFieldId(),
        CompanyBranchId: userinfo.getCompanyBranchId(),
        PlaceId: self._place_id,
        Action: actionName,
        Params: dataObjects,
        Sender: self._sender,
        Token: token,
      }),
      self.getWebSocketRequestId(SIGNALR_ACTION.PUBLISH)
    )
    .catch(function(err) {
      logError('socket.invoke Publish', err);
    });
};

// オブジェクト操作データを蓄積
//  修正して未使用になった
_client.prototype.push = function(data) {
  var self = this;
  if (data.action == 'add' && data.objects) {
    if (data.objects[0].width == 0 && data.objects[0].height == 0) {
      //サイズが0のものは画面上から消す
      let obj = fabric.eg.getFromUuid(data.objects[0].uuid);
      drawing._canvas.remove(obj);
      drawing._canvas.requestRenderAll();
      self._data = [];
      return;
    }
    var objRemainingCount = drawing.getObjectRemainingCount();
    if (
      0 <= objRemainingCount &&
      objRemainingCount <= drawing._object_warning_remain_count
    ) {
      if (objRemainingCount === 0) {
        // 残数0の場合メッセージを表示する
        ui.showPopupMessage(
          '設置できるオブジェクト数が上限に達しました。不要なオブジェクトを削除してください。'
        );
      } else {
        // 残数が_object_warning_remain_count以下の場合メッセージを表示する
        ui.showPopupMessage(
          `設置できる残数が残り${objRemainingCount}個になりました`
        );
      }
    } else if (objRemainingCount < 0) {
      // 残数がない場合画面から消してメッセージを表示
      let obj = fabric.eg.getFromUuid(data.objects[0].uuid);
      drawing._canvas.egTextReachMaxCount = obj.type === 'egText';
      drawing._canvas.remove(obj);
      drawing._canvas.requestRenderAll();
      self._data = [];
      ui.showPopupMessage(
        '設置できるオブジェクト数が上限に達しました。不要なオブジェクトを削除してください。'
      );
      return;
    }
  }
  // オブジェクト数表示(画像表示用にsetTimeoutを使用)
  setTimeout(function() {
    drawing.updateObjectCount();
  }, 100);
};

// オブジェクト操作データを送信
_client.prototype.flush = function() {
  // 非同期で処理待ちしている間に_socketが変わっている場合があるので確保する
  // 場所変更時に変更後のroom_idで前のcanvasの情報で更新処理が実行されてしまうことの対策
  // _loadingをチェックして実行されないようにしているが実行されたとしてもsocketが閉じているのでサーバー側には到達しない
  return this.throttledFlush(this._socket);
};

// 連打対策としてthrottleする
_client.prototype.throttledFlush = _.throttle(async function(socket) {
  var self = this;
  if (socketConnected(socket) === false) {
    return;
  }

  // 場所変更でロード中は呼ばれても何もしない 先にroom_idが変更されてcanvasがまだ読み込まれていない状態
  if (self._loading) {
    return;
  }

  const token = await self.getToken();

  // getTokenの後で_loadingが変更されているかもしれないので再チェック
  if (self._loading) {
    return;
  }

  socket
    .invoke(
      'SendJson',
      JSON.stringify({
        ...self.getCanvasUpdateKey(),
        RoomId: self._room_id,
        FieldId: userinfo.getFieldId(),
        CompanyBranchId: userinfo.getCompanyBranchId(),
        PlaceId: self._place_id,
        UserType: userinfo.getUserType(),
        CanvasJson: drawing._canvas,
        ImageSrc: headReplace(
          drawing.getBackgroundFile(),
          `${API.nfs}/`,
          '/share/'
        ),
        Sender: self._sender,
        Token: token,
      }),
      self.getWebSocketRequestId(SIGNALR_ACTION.SEND_JSON)
    )
    .catch(function(err) {
      logError('socket.invoke SendJson', err);
    });

  // オブジェクト数表示(画像表示用にsetTimeoutを使用)
  setTimeout(function() {
    drawing.updateObjectCount();
  }, 100);
}, _sendJsonThrottleTime);

// 画面ロック(職長作業ロック)
_client.prototype.lockRoom = async function(isLocked) {
  var self = this;
  self.flush(); // save canvas before lock
  const token = await self.getToken();
  var json = {
    RoomId: self._room_id,
    FieldId: userinfo.getFieldId(),
    CompanyBranchId: userinfo.getCompanyBranchId(),
    Token: token,
  };
  if (isLocked) {
    // ロック
    console.log('debug', 'invoke Editlock');
    self._socket
      .invoke(
        'Editlock',
        JSON.stringify(json),
        self.getWebSocketRequestId(SIGNALR_ACTION.EDIT_LOCK)
      )
      .catch(function(err) {
        logError('socket.invoke Editlock', err);
      });
  } else {
    // ロック解除
    console.log('debug', 'invoke UnEditlock');
    self._socket
      .invoke(
        'UnEditlock',
        JSON.stringify(json),
        self.getWebSocketRequestId(SIGNALR_ACTION.UN_EDIT_LOCK)
      )
      .catch(function(err) {
        logError('socket.invoke UnEditlock', err);
      });
  }
};

// 部屋変更
_client.prototype.changeRoom = async function(room_id, place_id) {
  var self = this;
  if (self._room_id === room_id) {
    return;
  }

  if (socketConnected(self._socket) === false) {
    // 初回表示時はここでセット ソケットが未接続の状態で呼ばれる前提になっている
    self._room_id = room_id;
    self._place_id = place_id;
    return;
  }

  self._loading = true;
  self.clearCanvasUpdateKey();
  // 再接続する
  await self.endConnect();
  self._room_id = room_id;
  self._place_id = place_id;
  await self.startConnect();
};

// 部屋へ接続
_client.prototype.joinRoom = async function() {
  console.log('debug', 'invoke JoinRoom', this._room_id);
  var self = this;
  const token = await self.getToken();
  self._socket
    .invoke(
      'JoinRoom',
      JSON.stringify({
        RoomId: self._room_id,
        ClientId: self._clientId,
        Token: token,
      }),
      self.getWebSocketRequestId(SIGNALR_ACTION.JOIN_ROOM)
    )
    .then(function() {
      console.log('debug', 'invoke LoadCanvas', socketConnected(self._socket));
      // Canvas読み込み
      self._socket
        .invoke(
          'LoadCanvas',
          JSON.stringify({
            RoomId: self._room_id,
            FieldId: userinfo.getFieldId(),
            CompanyBranchId: userinfo.getCompanyBranchId(),
            PlaceId: self._place_id,
            Token: token,
          }),
          self.getWebSocketRequestId(SIGNALR_ACTION.LOAD_CANVAS)
        )
        .catch(function(err) {
          if (err.message.includes('Invocation canceled')) {
            console.log('LoadCanvas の送信前にキャンセルされました', err);
          } else {
            logError('socket.invoke LoadCanvas', err.message);
          }
        });
    })
    .catch(function(err) {
      if (err.message.includes('Cannot send data')) {
        console.log('JoinRoom の送信前にキャンセルされました', err);
      } else if (err.message.includes('Invocation canceled')) {
        console.log('JoinRoom の送信前にキャンセルされました', err);
      } else {
        logError('socket.invoke JoinRoom', err);
      }
    });
};

// 部屋取得
_client.prototype.getRoomId = function() {
  var self = this;
  return self._room_id;
};

// コピー
_client.prototype.copy = async function(room_id) {
  var self = this;
  const token = await self.getToken();
  self._socket
    .invoke(
      'CopyCanvas',
      JSON.stringify({
        RoomId: self._room_id,
        CopyRoomId: room_id,
        FieldId: userinfo.getFieldId(),
        CompanyBranchId: userinfo.getCompanyBranchId(),
        PlaceId: self._place_id,
        Sender: self._sender,
        Token: token,
      }),
      self.getWebSocketRequestId(SIGNALR_ACTION.COPY_CANVAS)
    )
    .catch(function(err) {
      logError('socket.invoke CopyCanvas', err);
    });
};

// 背景画像更新
_client.prototype.flushBackgroundImage = async function(imageSrc = '', socket) {
  var self = this;
  const currentSocket = socket || self._socket;

  const token = await self.getToken();
  if (self._loading) {
    return;
  }
  currentSocket
    .invoke(
      'SetBackgroundImage',
      JSON.stringify({
        RoomId: self._room_id,
        FieldId: userinfo.getFieldId(),
        CompanyBranchId: userinfo.getCompanyBranchId(),
        PlaceId: self._place_id,
        ImageSrc: headReplace(imageSrc, `${API.nfs}/`, '/share/'),
        Token: token,
      }),
      self.getWebSocketRequestId(SIGNALR_ACTION.SET_BACKGROUND_IMAGE)
    )
    .catch(function(err) {
      logError('socket.invoke SetBackgroundImage', err);
    });
};

// 印刷範囲更新
_client.prototype.flushPrintRange = async function(printRange) {
  console.log('debug', 'invoke SetPrintRange', printRange);
  var self = this;
  const token = await self.getToken();
  self._socket
    .invoke(
      'SetPrintRange',
      JSON.stringify({
        RoomId: self._room_id,
        FieldId: userinfo.getFieldId(),
        CompanyBranchId: userinfo.getCompanyBranchId(),
        PlaceId: self._place_id,
        CanvasHeight: printRange.height,
        CanvasWidth: printRange.width,
        CanvasTop: printRange.top,
        CanvasLeft: printRange.left,
        TransformPx: printRange.transformPx,
        TransformPy: printRange.transformPy,
        Token: token,
      }),
      self.getWebSocketRequestId(SIGNALR_ACTION.SET_PRINT_RANGE)
    )
    .catch(function(err) {
      logError('socket.invoke SetPrintRange', err);
    });
};

_client.prototype.canPrint = function() {
  return _.isNil(this.printWindow);
};

_client.prototype.onPrintBefore = function() {
  this.printWindow = window.open('/LayoutPrint', '_blank');
  ui.showLoadingMessage(messageUtility.getMessage('I-000-047'));
};

_client.prototype.onPrint = function(path) {
  // closedで判定してもonPrintの前にthis.printWindowが閉じられていると
  // this.printWindowのプロパティにアクセスするとエラーになる場合があるのでtrycatch
  try {
    if (this.printWindow && !this.printWindow.closed) {
      // Chromeの場合だとpdfファイル開かずにダウンロードする設定があるのでメッセージを消しておく
      const printingMessage = this.printWindow.document.getElementById(
        'printingMessage'
      );
      // BLDE_V2-22883 : id '#printingMessage' sometimes is not rendered
      // check before change style
      if (printingMessage) {
        printingMessage.style.display = 'none';
      }
      this.printWindow.location.href =
        this.url + encodeURI(path.replace('/share', ''));
    }
  } catch (e) {
    console.error(e);
  } finally {
    this.printWindow = null;
    ui.printClose();
    ui.showPopupMessage(messageUtility.getMessage('I-000-048'));
  }
};

_client.prototype.onPrintError = function(message) {
  try {
    if (this.printWindow && !this.printWindow.closed) {
      this.printWindow.close();
      this.printWindow = null;
    }
  } catch (e) {
    console.error(e);
  } finally {
    ui.printClose();
    ui.showPopupMessage(message);
    setTimeout(function() {
      location.reload();
    }, 5000);
  }
};

// 印刷
_client.prototype.getPdf = async function(params) {
  var self = this;
  if (!self.canPrint()) {
    return;
  }
  self.onPrintBefore();
  const token = await self.getToken();
  // placeIdはサーバ側はRoomIdsから取得
  self._socket
    .invoke(
      'Print',
      JSON.stringify({
        FieldId: userinfo.getFieldId(),
        FieldName: userinfo.getFieldName(),
        CompanyBranchId: userinfo.getCompanyBranchId(),
        RoomIds: params.roomIds,
        Dates: params.dates,
        Places: params.places,
        CanvasCount: params.roomIds.length,
        Token: token,
      }),
      self.getWebSocketRequestId(SIGNALR_ACTION.PRINT)
    )
    .catch(function(err) {
      logError('socket.invoke Print', err);
      ui.printClose();
      // Invocation canceled due to connection being closed
      ui.showPopupMessage(messageUtility.getMessage('E-001-353'));
      // 最印刷できるようにする
      self.init();
    });
};

// 印刷 分割画面
_client.prototype.getSplitPdf = async function(params) {
  var self = this;
  if (!self.canPrint()) {
    return;
  }
  self.onPrintBefore();
  const token = await self.getToken();

  // placeIdはサーバ側はRoomIdsから取得
  self._socket
    .invoke(
      'SplitPrint',
      JSON.stringify({
        FieldId: userinfo.getFieldId(),
        FieldName: userinfo.getFieldName(),
        CompanyBranchId: userinfo.getCompanyBranchId(),
        RoomIds: params.roomIds,
        Dates: params.dates,
        Places: params.places,
        CanvasCount: params.splitNum,
        Token: token,
      }),
      self.getWebSocketRequestId(SIGNALR_ACTION.SPLIT_PRINT)
    )
    .catch(function(err) {
      logError('socket.invoke SplitPrint', err);
      ui.printEnd();
      // Invocation canceled due to connection being closed
      ui.showPopupMessage(messageUtility.getMessage('E-001-353'));
      // 再印刷できるようにする
      self.init();
    });
};

// キャンバス情報取得
_client.prototype.loadMultipleCanvas = async function(roomId) {
  var self = this;
  console.log(
    'debug',
    'invoke loadMultipleCanvas',
    socketConnected(self._socket)
  );
  if (socketConnected(self._socket) === false) {
    return;
  }
  const token = await self.getToken();
  self._socket
    .invoke(
      'LoadMultipleCanvas',
      JSON.stringify({
        RoomId: roomId,
        FieldId: userinfo.getFieldId(),
        CompanyBranchId: userinfo.getCompanyBranchId(),
        //PlaceId: String(places.getPlaceId()),
        // 分割表示で場所変更しても背景が切り替わらない問題への対応
        // 記述内容はよくないですが、まず大丈夫だと思います（中村）
        PlaceId: String(roomId.split('-')[0]),
        Token: token,
      }),
      self.getWebSocketRequestId(SIGNALR_ACTION.LOAD_MULTIPLE_CANVAS)
    )
    .catch(function(err) {
      logError('socket.invoke LoadMultipleCanvas', err);
    });
};

const canvasClient = new _client();

window.onbeforeunload = () => {
  // ie11ではwebsocketの接続上限が6でリロード前に閉じないと残ってしまうので閉じる
  // 6を超えるとwebsocket接続が出来ずLongPollingになる
  drawing.beforeExitConstructionPlacementPlaces().finally(() => {
    canvasClient.endConnect();
  });
};

export const client = canvasClient;



// WEBPACK FOOTER //
// ./src/canvas/constructionPlacement/client_v2.js